import { Anchor, Box, Button, Checkbox, Divider, Group, Input, MultiSelect, NumberInput, SegmentedControl, Select, Stack, Table, Text, Textarea, ThemeIcon } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useDisclosure } from '@mantine/hooks';
import { FormInputWrapper } from 'core/components/';
import PrioritySelectItem from 'core/components/prioritySelect/PrioritySelectItem';
import CustomDatePicker from 'core/components/datePicker/CustomDatePicker';
import moment from 'moment';

import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { AppConstants, PriorityTypes, SampleGrades, shotChannels } from 'utils/constants';

import { logger } from 'utils/logger';
import { getClientLabel, getCompany, getItemPriority } from 'utils/helper';

const SampleEdit = ({ sample, onCancel, onSubmit, aggData }) => {
    const [active, handlers] = useDisclosure(false);
    const [isSaving, setIsSaving] = useState(false);
    const company = getCompany(aggData);
    // const theme = useMantineTheme();
    // const [files, setFiles] = useState([]);
    // const dispatch = useDispatch();

    // const [seasonData, setSeasonData] = useState([
    //     { value: 'winter', label: 'Winter' },
    //     { value: 'spring', label: 'Spring' },
    // ]);
    /*
    const previews = files.map((file, index) => {
      return (
        <Group key={index} position='apart' mt={'lg'} mb={'sm'} >
            <Group spacing={'xs'}>
                <ThemeIcon radius="xl">
                    <IconFile size={16} />
                </ThemeIcon>

                <Text size={'sm'}>{file.name}</Text>
            </Group>
            <Button variant='subtle' onClick={() => setFiles([])}>Remove</Button>
        </Group>
      );
    }); */

    const form = useForm({
        initialValues: {
            ...sample,
            sampleCount: sample.sampleCount && sample.sampleCount.length ? parseInt(sample.sampleCount) : 0,
            photoCode: sample.instructions['Web Photography Code'],
            otbDate: sample.instructions['Web Stock OTB Date'] && sample.instructions['Web Stock OTB Date'].length ? moment(sample.instructions['Web Stock OTB Date']).toDate() : null,
            sampleGrade: sample.sampleGrade ?? SampleGrades[0].value,
            multiShotFlag: sample.multiShotFlag ?? '',
            outfittingFlag: sample.outfittingFlag ?? '',
            departmentStr: sample.instructions['departmentStr'] && sample.instructions['departmentStr'].length ? sample.instructions['departmentStr'] : '',
            channels: sample.channels ? sample.channels : [],
            assocStyles: sample.childStyles ? sample.childStyles.map((style) => style.stylenumber) : [],
            priority: sample.priority ?? PriorityTypes[1].value,
        },

        validate: {
            photoCode: (value) => (value.length ? null : 'Invalid code'),
        },
    });

    useEffect(() => {
        logger.log(active, form);
        if (!active) {
            logger.log('toggling focus ');
            setTimeout(() => {
                handlers.toggle();
            }, 1000);
        }
    }, [active, handlers, form]);

    //   useEffect(() => {

    //     // Specify how to clean up after this effect:
    //     return function cleanup() {
    //       logger.log('cleanup');
    //       if(active)handlers.toggle();
    //     };
    //   });

    /**
     * Function to submit values to create a new sample
     * @param {*} values
     */
    const formHandler = (values) => {
        // dispatch(updateSampl(values))
        setIsSaving(true);
        onSubmit(values);
    };

    
    const selectedPriority = form.values.priority ? getItemPriority(form.values.priority) : null;
logger.log(selectedPriority, 'selectedPriority', form.values.priority);
    const rows = sample.childStyles?.map((element, idx) => {
        return (
            <tr key={idx}>
                <td>
                    <Group sx={{ flexShrink: 0 }}>
                        <Box sx={{ flexShrink: 1 }}>
                            <Anchor size='sm'>
                                <Text size='sm' lineClamp={1} sx={{ maxWidth: '500px' }}>
                                    {element.stylenumber}
                                </Text>
                            </Anchor>
                            {element['instructions']['Name']}
                            {/* <Text size='xs' color='dimmed'>
                                {element.id}
                            </Text> */}
                        </Box>
                    </Group>
                </td>
                {/* <td>{element['instructions']['Name']}</td> */}
                <td>{element['instructions']['department']}</td>
                {/* <td>{element.photographyCount}</td>
                {/* <td>
                    {status ? (
                        <Group noWrap>
                            <Indicator color={status.colors.primary} sx={{ zIndex: 0 }}></Indicator>
                            <Text sx={{ textTransform: 'capitalize' }}>{status.label}</Text>
                        </Group>
                    ) : null}
                </td> */}

                {/* <td><Badge variant='gradient' gradient={{ from: '#ed6ea0', to: '#ec8c69', deg: 35 }}>{distSelections[0]}</Badge></td> */}
            </tr>
        );
    });

    return (
        <>
            <form onSubmit={form.onSubmit((values) => formHandler(values))}>
                <FormInputWrapper label='Photo Code' required labelWidth={180}>
                    <Input id='photo-code' required placeholder='Enter Photo Code' variant={AppConstants.inputVariant} {...form.getInputProps('photoCode')} />
                </FormInputWrapper>
                <FormInputWrapper label='Style' labelWidth={180}>
                    <Input id='input-style' disabled variant={AppConstants.inputVariant} {...form.getInputProps('seasonSort')} />
                </FormInputWrapper>
                <FormInputWrapper label='Name' labelWidth={180}>
                    <Input id='input-name' disabled placeholder='Enter Name' variant={AppConstants.inputVariant} {...form.getInputProps('instructions.Name')} />
                </FormInputWrapper>
                <Divider />
                <FormInputWrapper label='Priority' labelWidth={180}>
                    <Select
                        sx={{ width: 200 }}
                        data={PriorityTypes}
                        placeholder='Select Priority'
                        nothingFound='Nothing found'
                        itemComponent={PrioritySelectItem}
                        icon={
                            selectedPriority?.icon ? (
                                <ThemeIcon size="sm" variant="light" color={selectedPriority.color}>
                                    {selectedPriority.icon}
                                </ThemeIcon>
                            ) : null
                        }
                        {...form.getInputProps('priority')}
                    />
                </FormInputWrapper>
                <Divider />
                <FormInputWrapper label='Sample Count' labelWidth={180}>
                    <NumberInput defaultValue={0} sx={{ width: 200 }} id='input-count' placeholder='Enter Sample Count' variant={AppConstants.inputVariant} {...form.getInputProps('sampleCount')} />
                </FormInputWrapper>
                <FormInputWrapper label='Sample Grade' id='input-grade' labelWidth={180}>
                    <Select sx={{ width: 200 }} data={SampleGrades} placeholder='Select Grade' nothingFound='Nothing found' {...form.getInputProps('sampleGrade')} />
                </FormInputWrapper>
                <FormInputWrapper label='Sample Notes' labelWidth={180}>
                    <Textarea id='input-sampleNotes' placeholder='' variant={AppConstants.inputVariant} {...form.getInputProps('sampleNotes')} />
                </FormInputWrapper>
                <Divider />
                <FormInputWrapper label='Multi Shot' labelWidth={180} description='Multi Shot includes both Talent and Flatlay shot'>
                    {/* <Checkbox {...form.getInputProps('multiShotFlag')}/> */}
                    <SegmentedControl
                        sx={{ width: '100%' }}
                        data={[
                            { label: 'Single Shot', value: '' },
                            { label: 'Multi Shot', value: 'Y' },
                        ]}
                        {...form.getInputProps('multiShotFlag')}
                    />
                </FormInputWrapper>
                {/* show if have assocStyles */}
                {sample.childStyles && sample.childStyles.length ? (
                    <FormInputWrapper label='Associated Styles' labelWidth={180} description='This is a group shot that includes the following styles'>
                        {/* <Input id='input-assocStyles' disabled placeholder='' variant={AppConstants.inputVariant} {...form.getInputProps('assocStyles')} /> */}
                        {/* <Text pt={4} size={'sm'} color={form.values.assocStyles.length ? '' : 'dimmed'}>
                            {form.values.assocStyles.length ? form.values.assocStyles.length : 'No Value'}
                        </Text> */}
                        {/* add a multiselect for the styles */}
                        <MultiSelect data={sample.childStyles.map((style) => ({ label: style.stylenumber, value: style.stylenumber }))} placeholder='Select Styles' searchable nothingFound='Nothing found' {...form.getInputProps('assocStyles')} />
                        {/* <Table withBorder sx={{ maxWidth: '100%' }}>
                            <thead>
                                <tr>
                                    <th>Style</th>                                    
                                    <th>Department</th>
                                    
                                </tr>
                            </thead>
                            <tbody>{rows}</tbody>
                        </Table> */}

                    </FormInputWrapper>
                ) : null}
                <Divider />

                <FormInputWrapper label='Outfitting Available' labelWidth={180} description='Are the correct styles available for styling?'>
                    <SegmentedControl
                        sx={{ width: '100%' }}
                        data={[
                            { label: 'Yes', value: 'Y' },
                            { label: 'No', value: '' },
                        ]}
                        {...form.getInputProps('outfittingFlag')}
                    />
                </FormInputWrapper>
                <Divider />
                <FormInputWrapper label='Channels' labelWidth={180} id='input-channels' description='Select the channels for the Event'>
                    <Stack spacing='xs' mt={4}>
                        {shotChannels.map((channel, index) => (
                            <Checkbox
                                key={index}
                                label={channel.label}
                                value={channel.value}
                                checked={form.values.channels?.includes(channel.value) || false}
                                onChange={(event) => {
                                    const currentChannels = form.values.channels || [];
                                    if (event.currentTarget.checked) {
                                        form.setFieldValue('channels', [...currentChannels, channel.value]);
                                    } else {
                                        form.setFieldValue(
                                            'channels',
                                            currentChannels.filter((c) => c !== channel.value),
                                        );
                                    }
                                }}
                            />
                        ))}
                    </Stack>
                </FormInputWrapper>
                <Divider />
                <FormInputWrapper label='Notes' description='Web Photography Notes' labelWidth={180}>
                    <Textarea id='input-name' disabled placeholder='' variant={AppConstants.inputVariant} {...form.getInputProps('instructions.Web Photography Notes')} />
                </FormInputWrapper>
                <FormInputWrapper label='Sample Size' labelWidth={180}>
                    <Input id='input-name' sx={{ width: 200 }} disabled placeholder='' variant={AppConstants.inputVariant} {...form.getInputProps('instructions.Web Photography Sample Size')} />
                </FormInputWrapper>
                <FormInputWrapper label={getClientLabel(company, 'otbDate')} labelWidth={180}>
                    {moment(form.values.otbDate).isValid() ? (
                        <Group>
                            <CustomDatePicker disabled sx={{ width: 200 }} placeholder='' {...form.getInputProps('otbDate')} />
                        </Group>
                    ) : (
                        <Text size='sm' color='dimmed'>{sample.instructions['Web Stock OTB Date']}</Text>
                    )}
                    {/* <Input id='input-name' sx={{ width: 100 }} disabled placeholder='Enter OTB Date' variant={AppConstants.inputVariant} {...form.getInputProps('instructions.Web Stock OTB Date')} /> */}
                    {/* <Group>
                        <CustomDatePicker disabled sx={{ width: 200 }} placeholder='' {...form.getInputProps('otbDate')} />
                    </Group> */}
                </FormInputWrapper>
                <FormInputWrapper label='Style' labelWidth={180}>
                    <Input id='input-style' disabled placeholder='' variant={AppConstants.inputVariant} {...form.getInputProps('instructions.Web Photography Style')} />
                </FormInputWrapper>
                <FormInputWrapper label='Department' labelWidth={180}>
                    <Input id='input-department' disabled placeholder='' variant={AppConstants.inputVariant} {...form.getInputProps('departmentStr')} />
                </FormInputWrapper>

                {/* <FocusTrap active={true}> */}
                {/* <FormInputWrapper label='SKU' id='input-sku'>
                <Input id="input-sku" required placeholder="Enter SKU" data-autofocus variant={AppConstants.inputVariant} />
                </FormInputWrapper>

                <FormInputWrapper label='Name' id='input-sku'>
                <Input id="input-name" required placeholder="Enter Name" variant={AppConstants.inputVariant} />
                </FormInputWrapper>

                <FormInputWrapper label='Description' id='input-desc'>
                <Textarea id='input-desc'
                    placeholder="Description" variant={AppConstants.inputVariant}
                />
                </FormInputWrapper>               

                <FormInputWrapper label='Event' id='input-season'>
                <Select
                    data={seasonData}
                    placeholder="Select Season"
                    nothingFound="Nothing found"
                    searchable
                    creatable
                    getCreateLabel={(query) => `+ Create ${query}`}
                    onCreate={(query) => {
                      const item = { value: query, label: query };
                      setSeasonData((current) => [...current, item]);
                      return item;
                    }}
                  />
                </FormInputWrapper>        


                <FormInputWrapper label='Tags' id='input-tags'>
                <Input id='input-tags'
                    placeholder="Tags" variant={AppConstants.inputVariant}
                />
                </FormInputWrapper>          */}
                {/* <FormInputWrapper label='Hero CAD' id='input-desc' description='Upload the CAD file for this sample. CAD file should be of type SVG.'>
                <SampleDropzone></SampleDropzone>
                </FormInputWrapper>       */}
                <Group position='right' mt='md'>
                    <Button type='submit' loading={isSaving}>
                        Update
                    </Button>
                </Group>
                {/* </FocusTrap> */}
            </form>
        </>
    );
};

const mapStateToProps = (state, props) => {
    //logger.log(state,props, ' mapstate')
    return {
        user: state.auth.user,
        aggData: state.appReducer.aggData,
        // sample: state.warehouse.selectedSample,
        success: state.warehouse.success,
        error: state.warehouse.error,
    };
};

const mapDispatch = {};

export default connect(mapStateToProps, mapDispatch)(SampleEdit);
